var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSocialIconFlickrd67Aa97Cb9A60Db08Ed2130C81Bd997F(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.536,
    height: 29.536,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 28733"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 12655",
    fill: "#ff0084",
    d: "M5.635 9h9v13h-9z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 12656",
    fill: "#0063dc",
    d: "M14.635 10h10v10h-10z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 65",
    d: "M14.768 0a14.768 14.768 0 1014.768 14.768A14.768 14.768 0 0014.768 0zm-3.889 17.967a3.2 3.2 0 113.2-3.2 3.2 3.2 0 01-3.2 3.2zm7.779 0a3.2 3.2 0 113.2-3.2 3.2 3.2 0 01-3.2 3.2z",
    fill: "#d1d2d4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialIconFlickrd67Aa97Cb9A60Db08Ed2130C81Bd997F);
export default __webpack_public_path__ + "static/media/social-icon-flickr.d67aa97cb9a60db08ed2130c81bd997f.9a145da967929a00a258fb5edb53ade4.svg";
export { ForwardRef as ReactComponent };